import {
  getGoogleAnalyticsClientId,
  getVid,
  getXsollauid,
  getCookie,
} from './cookies';
import {
  firstContentfulPaintTime,
  netType,
  getLanguage,
  getJavaEnabled,
  getNotificationPermission,
  isIframe,
  getCookiesEnabled,
  adBlockExists,
} from './browser';
import {
  getDocumentCharset,
  getViewportSize,
  getDocumentTitle,
  getUtmParameters,
  getValueFromUrl,
} from './document';
import { getTimezone } from './time';
import { eventProperties } from './events';
import packageInfo from '../package.json';

export const send = async (config, url, data) => {
  if (config.dfp) {
    data.dfp = config.dfp;
    data.counter_id = config.counterId;
    data.browser_name = config.browserName;
    data.browser_major = config.browserMajor;
    data.user_agent = config.ua;
    data.utm = getUtmParameters();

    if (url === config.hitUrl) {
      data.ident = prepareBrowserInfo(config);
    }

    if (config.xsollauid) {
      data.xsollauid = config.xsollauid;
    }

    if (!config.xsollauid && config.hitCount === 0) {
      config.hitCount = 1;
      sendXHR(config, url, data);
    } else if (!config.xsollauid && config.hitCount === 1) {
      setTimeout(function () {
        config.hitCount = 2;
        send(config, url, data);
      }, 1000);
    } else {
      sendXHR(config, url, data);
    }
  }
};

export const sendXHR = (config, url, data) => {
  if (window.XMLHttpRequest) {
    const body =
      typeof data !== 'string'
        ? JSON.stringify({
            ...data,
            library_version: packageInfo.version,
            ip: config.ip,
          })
        : JSON.stringify({
            ...JSON.parse(data),
            library_version: packageInfo.version,
            ip: config.ip,
          });

    const xhr = new XMLHttpRequest();
    try {
      xhr.open('POST', url, true);
    } catch (e) {
      return false;
    }
    xhr.withCredentials = true;
    xhr.timeout = 10000;
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.ontimeout = function () {
      sendXHR(config, url, body);
    };
    xhr.onload = function () {
      updateXsollauid(config, xhr);
    };
    xhr.send(body);
    return true;
  }
  return false;
};

const updateXsollauid = (config, xhr) => {
  const xsollauidFromUrl = getValueFromUrl(xhr.responseURL, '_xm');
  if (xsollauidFromUrl && xsollauidFromUrl !== config.xsollauid) {
    config.xsollauid = getXsollauid(xsollauidFromUrl, config.counterId);
  } else {
    const xsollauidFromBody = getValueFromBody(xhr.responseText, 'xsollauid');
    if (xsollauidFromBody && xsollauidFromBody !== config.xsollauid) {
      config.xsollauid = getXsollauid(xsollauidFromBody, config.counterId);
    }
  }
};

const getValueFromBody = (body, key) => {
  try {
    const parsedBody = body ? JSON.parse(body) : null;
    return parsedBody ? parsedBody[key] : null;
  } catch (e) {
    return null;
  }
};

export const setXsollauidFromUrl = (config, url) => {
  const xm = getValueFromUrl(url, '_xm');

  if (xm) {
    config.xsollauid = getXsollauid(xm, config.counterId);
  } else {
    const xsollauid = getValueFromUrl(url, '_xsollauid');
    if (xsollauid && xsollauid !== config.xsollauid) {
      config.xsollauid = getXsollauid(xsollauid, config.counterId);
    }
  }
};

const prepareBrowserInfo = (Config) => {
  const p = {};
  const screen = window.screen;
  p.ntf = getNotificationPermission();
  const net = netType();
  net !== '' && (p.net = net);

  p.t = getDocumentTitle();
  p.pc = getDocumentCharset();
  p.tz = getTimezone();

  const vs = getViewportSize();
  p.wcw = vs[0];
  p.wch = vs[1];

  p.plt = firstContentfulPaintTime();
  p.lcp = Config.sendLoadMetrics ? eventProperties.LCP : 0;

  p.la = getLanguage();
  p.j = getJavaEnabled() ? 1 : 0;

  p.clid = Config.clientId;
  p.vid = getVid(Config.visitId, Config.counterId);
  p.gacid = getGoogleAnalyticsClientId();

  p.c = getCookiesEnabled() ? 1 : 0;
  p.sw = screen.width;
  p.sh = screen.height;
  p.sc = screen.colorDepth || screen.pixelDepth;
  isIframe() && (p.ifr = 1);

  const yid = getCookie('_ym_uid');
  const pv = getCookie('paystation_visit');
  const cv = getCookie('corpsite_visit');
  const pav = getCookie('pa_visit');
  const dv = getCookie('dev_visit');
  const fvp = getCookie('first_visit');

  if (yid) p.yid = yid;
  if (pv) p.pv = pv;
  if (cv) p.cv = cv;
  if (pav) p.pav = pav;
  if (dv) p.dv = dv;
  if (fvp) p.fvp = fvp;

  p.adb = adBlockExists(Config) ? 1 : 0;

  return p;
};
